import * as size from './size.js'

export const assets = [
    // Image
    { alias: 'card0',    src: `./image/card/00-TheFool.jpg` },
    { alias: 'card1',    src: `./image/card/01-TheMagician.jpg` },
    { alias: 'card2',    src: `./image/card/02-TheHighPriestess.jpg` },
    { alias: 'card3',    src: `./image/card/03-TheEmpress.jpg` },
    { alias: 'card4',    src: `./image/card/04-TheEmperor.jpg` },
    { alias: 'card5',    src: `./image/card/05-TheHierophant.jpg` },
    { alias: 'card6',    src: `./image/card/06-TheLovers.jpg` },
    { alias: 'card7',    src: `./image/card/07-TheChariot.jpg` },
    { alias: 'card8',    src: `./image/card/08-Strength.jpg` },
    { alias: 'card9',    src: `./image/card/09-TheHermit.jpg` },
    { alias: 'card10',   src: `./image/card/10-WheelOfFortune.jpg` },
    { alias: 'card11',   src: `./image/card/11-Justice.jpg` },
    { alias: 'card12',   src: `./image/card/12-TheHangedMan.jpg` },
    { alias: 'card13',   src: `./image/card/13-Death.jpg` },
    { alias: 'card14',   src: `./image/card/14-Temperance.jpg` },
    { alias: 'card15',   src: `./image/card/15-TheDevil.jpg` },
    { alias: 'card16',   src: `./image/card/16-TheTower.jpg` },
    { alias: 'card17',   src: `./image/card/17-TheStar.jpg` },
    { alias: 'card18',   src: `./image/card/18-TheMoon.jpg` },
    { alias: 'card19',   src: `./image/card/19-TheSun.jpg` },
    { alias: 'card20',   src: `./image/card/20-Judgement.jpg` },
    { alias: 'card21',   src: `./image/card/21-TheWorld.jpg` },
    { alias: 'cardBack', src: `./image/card/CardBacks.jpg` },

    // Font
    // "alias" can't use for "fontFamily".
    // ex) NotoSerifJP-Medium.ttf -> NotoSerifJP Medium
    //{ alias: 'f1', src: './font/NotoSerifJP-Medium.ttf' },      // Development version
    { alias: 'f1', src: './font_min/NotoSerifJP-Medium.ttf' },  // Production version
];
export const fontDefault = 'NotoSerifJP Medium'

// Init Image
export async function load() {
    // Load single
    // const texture = await Assets.load('./image/card/00-TheFool.jpg');
    // const card0 = new Sprite(texture);

    // Load assets
    await PIXI.Assets.load(assets);

    // Init sprite
    //const sprite = PIXI.Sprite.from('cardBack');    // alias

    // Cards
    const cards = [];
    for (let i = 0; i < 22; i ++) {
        // Load texture
        const alias1 = `card${i}`;
        const alias2 = 'cardBack';
        const front = PIXI.Texture.from(alias1);
        const back = PIXI.Texture.from(alias2);

        // Sprite
        const sprite = new PIXI.Sprite(back);
        cards.push(sprite);

        // Swap texture
        sprite.__front = front;
        sprite.__back = back;
        sprite.setSide = function(isFront) {
            this.texture = isFront ? this.__front : this.__back;
        };

        // Info
        sprite.__id = assets.find(x => x.alias === alias1).src.replace(/^.+\/|\..+$/g, '');
        sprite.__indexInitial = i;
        sprite.__indexSort = i;

        // Scale and anchor
        sprite.__scale = 100 / sprite.width * size.rateX();  // Defalt Scale
        sprite.scale = sprite.__scale;
        sprite.anchor.x = 0.5;
        sprite.anchor.y = 0.5;
    }

    return { cards };
}
